export interface Facility {
    accountId: string,
    ean: string,
    parentEAN: string,
    facilityName: string,
    facilityAddress: string,
    facilityCity: string,
    facilityState: string,
    facilityZip: string,
    facilityCountry: string,
    isActive: string,
    reltio_UpdatedOn: string,
    reltio_CreatedOn: string,
    updatedOn: string,
    version: string
}

export const init_Facility = {
    accountId: '',
    ean: '',
    parentEAN: '',
    facilityName: '',
    facilityAddress: '',
    facilityCity: '',
    facilityState: '',
    facilityZip: '',
    facilityCountry: '',
    isActive: '',
    reltio_UpdatedOn: '',
    reltio_CreatedOn: '',
    updatedOn: '',
    version: ''
}

export interface Institution {
    institutionId: string,
    name: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zipCode: string,
    country: string,
    createdOn: string
}

export const init_Institution: Institution = {
    institutionId: '',
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    createdOn: ''
}

export interface BasicInfo {
    firstName: string,
    lastName: string,
    phoneNumber: string,
    mobileNumber: string,
    faxNumber: string,
    accountNumber: string,
    department: string,
    position: string,
    isActive: boolean | null,
    authLocale: string
}

export const init_BasicInfo: BasicInfo = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    mobileNumber: '',
    faxNumber: '',
    accountNumber: '',
    department: '',
    position: '',
    isActive: null,
    authLocale: ''
}

export interface LanguageNames {
    [key: string]: string
}

export interface Application {
    id: string, 
    name: string,
    isActive: boolean
}

export interface RegistrationValue {
    fieldName: string,
    displayText: string,
    values: Array<OptionItem>
}

export interface PositionValue {
    titles: Position[]
}

interface Position {
    [key: string]: string;
}

export interface OptionItem {
    name: string,
    value: string
}

export interface CareSettingOptionItem {
    name: string,
    value: string
    className: string
}

export interface customRegisterValueIitem {
    fieldName: string,
    values: any
}